<template>
  <div>
    <div class="flex justify-between items-center mb-4">
      <h3 class="text-sm font-semibold">Export targets</h3>
      <base-button @click="addNewOpen = !addNewOpen" size="small" type="button">
        <span v-if="addNewOpen">Cancel</span>
        <span v-else><icon-plus /> Add new</span>
      </base-button>
    </div>

    <admin-export-target-form
      v-if="addNewOpen"
      :clientId="clientId"
      @saved="addNewOpen = false"
      class="mb-8"
    />

    <base-notice v-else-if="targets.length === 0">
      No export targets were added yet
    </base-notice>
    <ul v-else>
      <li v-for="target in targets" :key="target.id" class="mb-1">
        <div class="flex bg-white">
          <div class="flex-1 flex justify-between py-2 px-4">
            {{ target.identifier }}
          </div>
          <base-button @click="target.editing = !target.editing" type="button">
            <icon-edit />
          </base-button>
        </div>

        <admin-export-target-form
          v-if="target.editing"
          :clientId="clientId"
          :target="target"
          @saved="target.editing = false"
          class="mb-4"
        />
      </li>
    </ul>
  </div>
</template>

<script>
import { ref } from '@vue/composition-api';
import AdminExportTargetForm from './AdminExportTargetForm.vue';

export default {
  components: { AdminExportTargetForm },
  props: {
    clientId: Number,
    targets: Array,
  },
  setup() {
    const addNewOpen = ref(false);

    return {
      addNewOpen,
    };
  },
};
</script>
